import DatePicker from "components/app/function/DatePicker";

import { Textarea } from "components/ui/textarea";
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from "components/ui/select";

const ChangeShiftApplicationForm = ({ employeeInitRequest, handleChangeShiftRequest, changeShiftApplication, setChangeShiftApplication, setValuesRemarkChangeShift }: any) => {
  return (
    <>
      <div>
        <h4 className="text-xl font-semibold text-blue-600 mb-2"> Change Shift Detail </h4>

        <div className="grid grid-cols-6 gap-4 mb-4 mt-2">
          <>
            <div>
              <label>Working Date</label>
              <DatePicker
                disabled={employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved"}
                className="py-3 h-[45px] text-[15px] border border-gray-300 "
                value={changeShiftApplication.working_date}
                onChange={(e) => handleChangeShiftRequest("working_date", e)}
              />
            </div>
            <div className=" relative overflow-hidden px-3 pb-2">
              <label className="mb-2">To Shift</label>
              <Select
                disabled={employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved"}
                value={changeShiftApplication.to_shift_group_id}
                onValueChange={(val: any | number) => {
                  setChangeShiftApplication((prev: any) => ({
                    ...prev,
                    to_shift_group_id: val,
                  }));
                }}
              >
                <SelectTrigger className=" py-[22px] text-[15px]  ">
                  <SelectValue className="" />
                </SelectTrigger>
                <SelectContent className="text-[15px]">
                  <SelectGroup>
                    {employeeInitRequest?.document?.shift_groups?.map((item: any) => (
                      <SelectItem key={item.shift_group_id} value={item.shift_group_id}>
                        {item.local_description}
                      </SelectItem>
                    ))}
                  </SelectGroup>
                </SelectContent>
              </Select>
            </div>
          </>
        </div>
      </div>

      <div>
        <label> Reason </label>
        <Textarea
          disabled={employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved"}
          className="text-[15px] focus:border-none focus:border-1 mt-2"
          value={changeShiftApplication.remark}
          onChange={(e) => {
            handleChangeShiftRequest("remark", e.target.value);
            setValuesRemarkChangeShift(e.target.value);
          }}
          rows={4}
        />
      </div>
    </>
  );
};

export default ChangeShiftApplicationForm;
